import { forwardRef } from 'react';
import { DirectionClues } from "@bekodo/react-crossword"

const CluesDesktop = forwardRef(({ label_across, label_down }, ref) => {
    return <div className="clues-display">
        <div id="clues-desktop" className="flex gap-5 hidden md:flex clues-desktop">
            <DirectionClues direction="across" label={label_across} />
            <DirectionClues direction="down" label={label_down} />
        </div>
    </div>
})
export default CluesDesktop
